export default{'Menu':'Меню'};